import { Pipe, PipeTransform } from '@angular/core';
import { EMOJI_REGEX, EMOJI_REPLACE_REGEX } from '@shared/modules/comments/common/constants/emoji-regex';

@Pipe({
  name: 'isEmoji',
  standalone: false
})
export class IsEmojiPipe implements PipeTransform {
  transform(comment: string): boolean {
    if (!comment) {
      return false;
    }

    let match = comment.match(EMOJI_REGEX);
    let replacement = comment.replace(EMOJI_REPLACE_REGEX, '');
    return (match && match.length <= 10 && replacement.length === 0) || replacement === '️';
  }
}
